import { MessageSquare } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AttachmentChip } from "@/components/Attachments";
import { ReplyComposer } from "@/components/tickets/ReplyComposer";

const fmt = (iso) => new Date(iso).toLocaleString("en-GB", { dateStyle: "medium", timeStyle: "short" });

export const ConversationThread = ({
  ticket, canComment, canSendTemplate,
  comment, setComment, commentAttach, setCommentAttach,
  sending, onSubmit,
  sendToWhatsapp, setSendToWhatsapp,
  waWindow, onOpenWaTemplate,
}) => (
  <Card className="border-slate-200">
    <CardHeader className="pb-3">
      <CardTitle className="font-heading text-base flex items-center gap-2">
        <MessageSquare className="w-4 h-4 text-slate-500" /> Conversation
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-3">
      {(ticket.comments || []).length === 0 && (
        <div className="text-sm text-slate-400 py-6 text-center">No messages yet. Be the first to respond.</div>
      )}
      {(ticket.comments || []).map((c) => (
        <div key={c.id} className="border border-slate-200 rounded-lg p-4" data-testid={`comment-${c.id}`}>
          <div className="flex items-center justify-between mb-2">
            <div className="text-sm font-medium text-slate-800">{c.author_name}</div>
            <div className="text-xs text-slate-400">{fmt(c.created_at)}</div>
          </div>
          <div className="text-sm text-slate-700 whitespace-pre-wrap">{c.body}</div>
          {(c.attachment_ids || []).length > 0 && (
            <div className="flex flex-wrap gap-2 mt-3">
              {c.attachment_ids.map((fid) => <AttachmentChip key={fid} fileId={fid} />)}
            </div>
          )}
        </div>
      ))}

      <ReplyComposer
        ticket={ticket}
        canComment={canComment}
        canSendTemplate={canSendTemplate}
        comment={comment}
        setComment={setComment}
        commentAttach={commentAttach}
        setCommentAttach={setCommentAttach}
        sending={sending}
        onSubmit={onSubmit}
        sendToWhatsapp={sendToWhatsapp}
        setSendToWhatsapp={setSendToWhatsapp}
        waWindow={waWindow}
        onOpenWaTemplate={onOpenWaTemplate}
      />
    </CardContent>
  </Card>
);
